import Vue from 'vue'

import 'normalize.css/normalize.css'
import 'font-awesome/css/font-awesome.min.css';
// 引入element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/theme/element-00C0EF/index.css';

// 兼容IE
import 'babel-polyfill'

import '@/icons' // icon
import App from './App'
// vuex
import store from './store'
import router from './router'
import './router/permission'
//断点续传 分片上传
import uploader from 'vue-simple-uploader'
import VueCropper from 'vue-cropper'
import VueClipboard from 'vue-clipboard2'
import PinyinMatch from 'pinyin-match'
import kyPermission from './directive'
import dayjs from 'dayjs'

Vue.prototype.$pinyinmatch = PinyinMatch
Vue.config.productionTip = false

Vue.prototype.$dayjs = dayjs

Vue.use(kyPermission)
Vue.use(VueClipboard)
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(uploader)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js